import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./address.css";

function Address({
  profile,
  profileupdate,
  onSelectAddress,
}) {
  const location = useLocation();
  const [selectedAddressType, setSelectedAddressType] = useState("");

  const [addressData, setAddressData] = useState({});
  const [existingTypes, setExistingTypes] = useState([]);
  const [newLabel, setNewLabel] = useState("");
  const [newValue, setNewValue] = useState("");

  const [deletingKey, setDeletingKey] = useState(null);
  const [isAdding, setIsAdding] = useState(false);

  const MAX_ADDRESSES = 4;

  useEffect(() => {
    try {
      const parsed = JSON.parse(profile.address);
      setAddressData(parsed);
      setExistingTypes(Object.keys(parsed)); // ['A1', 'A2']
    } catch (error) {
      console.error("Failed to parse address JSON:", error);
    }
  }, [profile]);

  const handleDelete = async (deleteKey, action) => {
    if (!profileupdate) return;

    setDeletingKey(deleteKey); // disable only this button

    try {
      await profileupdate(deleteKey, action); // wait for delete to finish
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setDeletingKey(null); // re-enable button
    }
  };

  const handleAdd = async () => {
    if (!newLabel || !newValue) {
      alert("Please enter both label and address.");
      return;
    }

    setIsAdding(true);

    try {

      await profileupdate({ label: newLabel, value: newValue }, "add");
      setNewLabel("");
      setNewValue("");
    } catch (error) {
      console.error("Failed to add address:", error);
    } finally {
      setIsAdding(false);
    }
  };

  const handleSelect = (type) => {
    setSelectedAddressType(type);

    const entry = addressData[type];
    if (typeof entry === "string") {
      onSelectAddress?.(entry);
    } else if (typeof entry === "object") {
      const label = Object.keys(entry)[0];
      const value = entry[label];
      const formatted = `${label}, ${value}`;
      onSelectAddress?.(formatted);
    } else {
      onSelectAddress?.("");
    }
  };

  return (
    <div>
      <h2>Saved Addresses</h2>

      {existingTypes.length === 0 && <p>No addresses saved.</p>}

      {existingTypes.map((type, index) => {
        const isBagPage = location.pathname !== "/profile";
        const label = Object.keys(addressData[type] || {})[0] || type;
        const value =
          typeof addressData[type] === "string"
            ? addressData[type]
            : addressData[type]?.[label];
        const isSelected = selectedAddressType === type;

        const cardStyle = {
          border: isSelected ? "2px solid #007bff" : "1px solid #e0e0e0",
          borderRadius: "8px",
          padding: "16px",
          marginBottom: "12px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: isSelected ? "#f0f8ff" : "#fafafa",
          boxShadow: isSelected
            ? "0 2px 8px rgba(0, 123, 255, 0.2)"
            : "0 1px 3px rgba(0,0,0,0.1)",
          cursor: isBagPage ? "pointer" : "default",
          transition: "all 0.2s ease-in-out",
        };

        return (
          <div
            key={index}
            onClick={isBagPage ? () => handleSelect(type) : undefined}
            style={cardStyle}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              {/* Radio-style dot only for /bag */}
              {isBagPage && (
                <div
                  style={{
                    width: "18px",
                    height: "18px",
                    borderRadius: "50%",
                    border: "2px solid #007bff",
                    backgroundColor: isSelected ? "#007bff" : "transparent",
                    transition: "background-color 0.2s ease",
                  }}
                ></div>
              )}

              {/* Address Info */}
              <div>
                <strong
                  style={{
                    textTransform: "capitalize",
                    fontSize: "16px",
                    color: "#333",
                  }}
                >
                  {label}
                </strong>
                <p
                  style={{ margin: "4px 0 0", fontSize: "14px", color: "#555" }}
                >
                  {value}
                </p>
              </div>
            </div>

            {/* Delete Button */}
            <button
              disabled={deletingKey === type}
              style={{
                backgroundColor: deletingKey === type ? "#ccc" : "#ff4d4f",
                color: "#fff",
                border: "none",
                padding: "6px 12px",
                borderRadius: "5px",
                cursor: deletingKey === type ? "not-allowed" : "pointer",
                fontSize: "14px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                opacity: deletingKey === type ? 0.6 : 1,
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(type, "delete");
              }}
            >
              {deletingKey === type ? "Deleting..." : "Delete"}
            </button>
          </div>
        );
      })}

      {/* Deliver to this Address button for /bag */}
      {/* {location.pathname === "/bag" && selectedAddressType && (
        <div style={{ marginTop: "20px" }}>
          <button
            onClick={() => {
              const selectedValue = addressData[selectedAddressType];
              handleplaceorder({
                [selectedAddressType]: selectedValue,
              });
            }}
            style={{
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              padding: "10px 20px",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Deliver to this Address
          </button>
        </div>
      )} */}

      {/* Add New Address */}
      {existingTypes.length < MAX_ADDRESSES ? (
        <div
          style={{
            marginTop: "20px",
            padding: "10px",
            border: "1px dashed #ccc",
            borderRadius: "5px",
          }}
        >
          <h4>Add New Address</h4>

          <select
            value={newLabel}
            onChange={(e) => setNewLabel(e.target.value)}
            disabled={isAdding}
            style={{
              marginRight: "10px",
              padding: "5px",
              opacity: isAdding ? 0.6 : 1,
              cursor: isAdding ? "not-allowed" : "pointer",
            }}
          >
            <option value="">Select Label</option>
            <option value="home">Home</option>
            <option value="work">Work</option>
            <option value="others">Others</option>
          </select>

          <input
            type="text"
            placeholder="Address"
            value={newValue}
            onChange={(e) => setNewValue(e.target.value)}
            disabled={isAdding}
            style={{
              marginRight: "10px",
              padding: "5px",
              opacity: isAdding ? 0.6 : 1,
              cursor: isAdding ? "not-allowed" : "text",
            }}
          />

          <button
            onClick={handleAdd}
            disabled={isAdding}
            style={{
              backgroundColor: isAdding ? "#ccc" : "#28a745",
              color: "#fff",
              border: "none",
              padding: "6px 12px",
              borderRadius: "4px",
              cursor: isAdding ? "not-allowed" : "pointer",
              fontSize: "14px",
              opacity: isAdding ? 0.7 : 1,
            }}
          >
            {isAdding ? "Adding..." : "Add Address"}
          </button>
        </div>
      ) : (
        <p style={{ color: "gray", marginTop: "20px" }}>
          You’ve reached the maximum of 4 addresses.
        </p>
      )}
    </div>
  );
}

export default Address;
